<template>
    <ProfileOptionSelector :model="'shape'" :nextRoute="() => 'KindsPage'" />
</template>

<script>
export default {
    name: 'ShapesPage',
    mounted() {
        this.$nativeBridge.postMessage({
            action: 'sendFirebaseEvent',
            value: {
                category: 'signUpEvent',
                option: {
                    funnel: this.$route.name,
                    provider: this.$store.getters.payloads.signupData.provider || 'email',
                },
            },
        })
    },
}
</script>
